import { parseSearch } from "@faire/retailer-shared/search/searchRequest";
import { match as matchDiscoverRoute } from "@faire/web-api--source/routes/discover/searchTerm/match";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
export var useSearchPageParsedSearch = function() {
    var _matchDiscoverRoute;
    var _useLocation = useLocation(), search = _useLocation.search, pathname = _useLocation.pathname;
    var searchTerm = (_matchDiscoverRoute = matchDiscoverRoute(pathname)) === null || _matchDiscoverRoute === void 0 ? void 0 : _matchDiscoverRoute.params.searchTerm;
    return useMemo(function() {
        return parseSearch({
            search: search,
            discoverSearchTerm: searchTerm
        });
    }, [
        search,
        searchTerm
    ]);
};
